import { render, staticRenderFns } from "./ArtistsList.vue?vue&type=template&id=629bc8a2&"
import script from "./ArtistsList.vue?vue&type=script&lang=js&"
export * from "./ArtistsList.vue?vue&type=script&lang=js&"
import style0 from "./ArtistsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports